const toastState = ref([])


export const useToast = () => {
    const showToast = (title = 'عنوان', description = '', type = 'success', duration = 4000) => {
        toastState.value.push({
            open: true,
            title,
            description,
            type,
            duration
        });
    };

    return {
        toastState,
        showToast,
    };
}